/**
 * The most vehicles one per-vehicle scan covers; a larger group has to be narrowed first.
 *
 * Shared by the pages that read each vehicle on its own (vehicle-data-check, energy report), so
 * their limits and messages cannot drift apart.
 */
export const MAX_SCAN_VEHICLES = 500;
